// Breakpoints
export const BREAKPOINTS = {
    SMALL: 640,
    MEDIUM: 768,
    LARGE: 1024,
};

export const CONNECTIVITY_STATUS = {
    OFFLINE: 'OFFLINE',
    ONLINE: 'ONLINE',
};

export const DAYS_IN_WEEK = 7;

export const DATES = {
    FIRST_DAY_OF_WEEK: 1,
    DATETIME_FORMATS: {
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        DEFAULT_DATE: 'd MMM yyyy',
        WEEK_DAY_MONTH_DAY: 'EEEE d',
        WEEK_DAY_MONTH_DAY_TIME: 'EEEE d, HH:mm',
        WEEK_DAY_SHORT_MONTH_DAY_TIME: 'EEE d, HH:mm',
        WEEK_DAY_SHORT_FULL_TIME: 'EEE d MMM yyyy, HH:mm',
        LONG_MONTH: 'MMMM',
        LONG_MONTH_YEAR: 'MMMM, yyyy',
        LONG_DATE_TIME: 'd MMM yyyy, HH:mm',
        LONG_DATE_TIME_SECONDS: 'd MMM yyyy, HH:mm:ss',
        LONG_DATE_FULL_MONTH: 'd MMMM yyyy',
        LONG_DATE_FULL_TIME: 'd MMMM yyyy, HH:mm',
    },
    DAYS: [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
    ],
    MONTHS: [
        'january',
        'february',
        'march',
        'april',
        'may',
        'june',
        'july',
        'august',
        'september',
        'october',
        'november',
        'december',
    ],
    US: {
        DATETIME_FORMATS: {
            DEFAULT_DATE: 'MMM d yyyy',
            LONG_DATE_TIME: 'MMM d yyyy, h',
        },
        FIRST_DAY_OF_WEEK: 0,
    },
};

export const TIMES = {
    MILLISECONDS_PER_MINUTE: 60_000,
    SECONDS_PER_YEAR: 31_104_000,
    SECONDS_PER_MONTH: 2_592_000,
    SECONDS_PER_WEEK: 604_800,
    SECONDS_PER_DAY: 86_400,
    SECONDS_PER_HOUR: 3_600,
    SECONDS_PER_MINUTE: 60,
    MINUTES_PER_HOUR: 60,
};

export const NOTIFICATION_TYPES = {
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
};
export const EXTERNAL_URLS = {
    USING_THE_TERMINAL_DOC_URL: 'https://developers.everon.io/terminal',
    GOOGLE_MAPS_API: 'https://maps.googleapis.com/maps/api/js',
    WHAT_IS_EICHRECHT_DOC_URL:
        'https://help.evbox.com/s/article/What-is-Eichrecht',
    HOW_DO_I_DELETE_MY_ACCOUNT_URL:
        'https://help.evbox.com/s/article/How-do-I-delete-my-account-in-Everon',
    HELPCENTER_EVERON_WINDDOWN: '', //https://everon.io/support' //todo: URL
};
export const USER_LEVELS = {
    TENANT: 'TENANT',
    ACCOUNT: 'ACCOUNT',
    SUB_ACCOUNT: 'SUB_ACCOUNT',
};
// User roles
export const USER_ROLES = {
    ACCOUNT_STATION_ADMIN: 'accountStationAdmin',
    ACCOUNT_OWNER: 'accountOwner',
    SUB_ACCOUNT_OWNER: 'subAccountOwner',
    ACCOUNT_ADMIN: 'accountAdmin',
    TENANT_ADMIN: 'tenantAdmin',
    TECHNICAL_SUPPORT: 'technicalSupport',
    CUSTOMER_SUPPORT: 'customerSupport',
    SUPPORT_AGENT: 'supportAgent',
    ANONYMOUS: 'anonymous',
    SUB_ACCOUNT_ADMIN: 'subAccountAdmin',
    BILLING_PLAN_ADMIN: 'billingPlanAdmin',
    ROAMING_ADMIN: 'roamingAdmin',
    BRANDING: 'branding',
    DRIVER: 'driver',
};

export const ACCOUNT_INVITATION = {
    COUNTRY_SPECIFICATION: {
        ALREADY_SPECIFIED: 'ALREADY_SPECIFIED',
        DURING_REGISTRATION: 'DURING_REGISTRATION',
        AFTER_LOGIN: 'AFTER_LOGIN',
    },
    ACCOUNT_CREATION: {
        ON_BEHALF: 'ON_BEHALF',
        BY_OWNER: 'BY_OWNER',
    },
};

export const RECAPTCHA = {
    PUBLIC_SITE_KEY: '6LewOIMUAAAAAMqI4WjUAurCUxXb7GU1c__p2cA6',
    TEST_SITE_KEY: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
};

export const PAGINATION = {
    SIZES: [30, 50, 80, 100, 200],
};

export const API_ROUTES = {
    USERS: {
        GET: '/api/users/profiles/{userId}',
        INITIATE_PASSWORD_RESET: '/api/users/profiles/password-reset/initiate',
        VERIFY_PASSWORD_CODE: '/api/users/profiles/password-reset/verify-token',
        RESET_PASSWORD: '/api/users/profiles/password-reset',
        SIGN_UP: '/api/users/signup',
        UPDATE_INVITED_ACCOUNT:
            '/api/platform/sign-up/activation/:activationCode',
        ACTIVATE_SELF_SIGN_UP: '/api/users/signup/activation/:activationCode',
        VERIFY_ACTIVATION_CODE:
            '/api/users/activationToken/:activationCode/email',
        ACTIVATE_PROFILE: '/api/users/profiles/activate',
        SETUP_PROFILE: '/api/users/profiles/setup',
    },
    TENANTS: {
        BRANDING: {
            GET: '/api/tenants/branding',
            DELETE_LOGO: '/api/tenants/branding/images/logo',
            DELETE_BRAND: '/api/tenants/branding/images/brand',
            DELETE_ICON: '/api/tenants/branding/images/icon',
            COLORS: '/api/tenants/branding/colors',
        },
        TENANT_CONFIG: '/api/tenants/config/{tenantId}',
        TENANT_FEATURES: '/api/tenants/tenant-features',
        PLATFORM: {
            COUNTRIES: '/api/tenants/platform/countries',
            CURRENCIES: '/api/tenants/platform/currencies',
            RECAPTCHA: '/api/tenants/platform/recaptcha',
            RECAPTCHA_KEY: '/api/tenants/platform/configs/google-recaptcha-key',
            LANGUAGES: '/api/tenants/platform/languages',
            PLATFORM_VALIDATION: '/api/tenants/platform/validation',
        },
        TENANT_SETTINGS: {
            LANGUAGE: '/api/tenants/tenant-settings/language',
            SUPPORT_LINKS: '/api/tenants/tenant-settings/support-links',
            SAVE_SUPPORT_LINKS: '/api/tenants/tenant-settings/support-links',
            NOTIFICATIONS: '/api/tenants/tenant-settings/notifications',
            SAVE_NOTIFICATIONS: '/api/tenants/tenant-settings/notifications',
            UPDATE_LANGUAGE: '/api/tenants/tenant-settings/language',
        },
    },
    BILLING: {
        VALIDATION: '/api/billing/validation',
        SETTINGS: {
            SUPPORTED_COUNTRIES: '/api/billing/settings/supported-countries',
            COUNTRY_CURRENCIES: '/api/billing/settings/country-currencies',
            AVAILABLE_COUNTRIES: '/api/billing/settings/available-countries',
            HAS_AVAILABLE_COUNTRIES:
                '/api/billing/settings/available-countries',
            COUNTRIES: {
                LIST: '/api/billing/settings/countries',
                GET: '/api/billing/settings/countries/{id}',
                HAS_COUNTRIES: '/api/billing/settings/countries',
                SAVE: '/api/billing/settings/countries',
                UPDATE: '/api/billing/settings/countries/{countryId}',
                DELETE: '/api/billing/settings/countries/{countryId}',
            },
        },
        COMPANIES: {
            LIST: '/api/billing/companies',
            GET_COMPANY: '/api/billing/companies/{id}',
            SAVE: '/api/billing/companies',
            UPDATE: '/api/billing/companies/{companyId}',
            DELETE: '/api/billing/companies/{companyId}',
            HAS_COMPANIES: '/api/billing/companies',
        },
    },
    PLATFORM: {
        PASSWORD_CHECK: '/api/platform/password-check/strength',
    },
    TRANSACTIONS: {
        DOWNLOAD_RECEIPT:
            '/api/transactions/receipt/tenant/{tenantId}/transaction/{id}?&language={locale}',
        SEARCH_RECEIPTS:
            '/api/transactions/receipt/search/tenant/{tenantId}/card/{ccLastFourDigits}?startDate={startDate}&language={locale}',
        GET_EICHRECHT:
            '/api/transactions/eichrecht/tenant/{tenantId}/transaction/{id}',
    },
};

export const REGEX = {
    TARIFF: /^(\d{1,12})(\.\d{1,4})?$/,
    REIMBURSEMENT_RATE: /^(\d{1,8})([,|.]\d{1,4})?$/,
    VAT_TARIFF: /^(\d{1,2})([.|,]\d{1,2})?$/,
    ROAMING_CONNECTION_URL: /^(http|https):\/\/[\w-./]+$/,
    URL: /^(http|https):\/\/[\S]+$/,
    /*
    Contract ID regex

    * EMI3
    [A-Za-z]{2}   [A-Za-z0-9]{3}[cC]    [A-Za-z0-9]{8}   [A-Za-z0-9] |  # NLEVBC888AB888X
    [A-Za-z]{2}[*][A-Za-z0-9]{3}[*][cC] [A-Za-z0-9]{8}[*][A-Za-z0-9] |  # NL*EVB*C888AB888*X
    [A-Za-z]{2}-  [A-Za-z0-9]{3}-[cC]   [A-Za-z0-9]{8}-  [A-Za-z0-9] |  # NL-EVB-C888AB888-X

    * DIN SPEC 91286
    [A-Za-z]{2}   [A-Za-z0-9]{3}        [A-Za-z0-9]{6}   [A-Za-z0-9] |  # NLEVBC66AB66X
    [A-Za-z]{2}[*][A-Za-z0-9]{3}[*]     [A-Za-z0-9]{6}[*][A-Za-z0-9] |  # NL*EVB*C66AB66*X
    [A-Za-z]{2}-  [A-Za-z0-9]{3}-       [A-Za-z0-9]{6}-  [A-Za-z0-9]    # NLEVBC66AB66X
    */
    CONTRACT_ID:
        /^[A-Za-z]{2}[A-Za-z0-9]{3}[cC][A-Za-z0-9]{8}[A-Za-z0-9]$|^[A-Za-z]{2}[*][A-Za-z0-9]{3}[*][cC][A-Za-z0-9]{8}[*][A-Za-z0-9]$|^[A-Za-z]{2}-[A-Za-z0-9]{3}-[cC][A-Za-z0-9]{8}-[A-Za-z0-9]$|^[A-Za-z]{2}[A-Za-z0-9]{3}[A-Za-z0-9]{6}[A-Za-z0-9]$|^[A-Za-z]{2}[*][A-Za-z0-9]{3}[*][A-Za-z0-9]{6}[*][A-Za-z0-9]$|^[A-Za-z]{2}-[A-Za-z0-9]{3}-[A-Za-z0-9]{6}-[A-Za-z0-9]$/,

    // from page 5/449, page 379/449 OCPP 2.0.1 spec. Same regex as used by in BE validation.
    CARD_RFID: /^[A-Za-z0-9*\-_=:+|@.]{8,40}$/,
    STATION_IDENTITY_CODE: /^\S{1,48}$/,
    STATION_SECURITY_CODE: /^\S{1,36}$/,
    STATION_ARTICLE_NUMBER: /^\S{1,30}$/,
    STATION_SERIAL_NUMBER: /^\S{1,255}$/,
    STATION_EVBOX_G5_PLUS_SERIAL_NUMBER: /^\S{25}$/,
    BILLING_NUMBERING: /^(?=[0-9]{1,10}$)(0*[1-9]+[0-9]*)$/,
    INVOICING_NUMBERING: /^(?=[0-9]{1,8}$)(0*[1-9]+[0-9]*)$/,
    EMAIL: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
    PHONE: /^[+?\d]{6,20}$/,
    ALPHANUMERIC: /^[\d|a-zA-Z]*$/,
    EIN_NUMBER: /^\d{2}-\d{7}$/,
    GEO_COORDINATES:
        /^\s*[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)\s*,\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)\s*$/,
    PASSWORD_LENGTH_OKTA: /^.{12,}$/,
    ROUTING_NUMBER: /^\d{9}$/,
    BANK_ACCOUNT_NUMBER: /^\d{6,17}$/,
    ADDRESS_STATE: /^[a-zA-Z]{2}$/,
    CURRENCY_AMOUNT: /^(\d{1,8})(\.\d{1,2})?$/,
    PERCENTAGE: /^(\d{1,3})([,|.]\d{1,2})?$/,
    RANGE_110_1000: /^(1[1-9][0-9]|[2-9][0-9]{2}|1000)$/,
    RANGE_1_500: /^([1-9]|[1-9][0-9]|[1-4][0-9]{2}|500)$/,
    COLOR: /^#[A-Za-z0-9]{6}$/,
    /*
    VAT number regex source: https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch04s21.html

    (AT)U[0-9]{8} |                                                     # Austria
    (BE)[0-9]{10} |                                                     # Belgium
    (BG)[0-9]{9,10} |                                                   # Bulgaria
    (CY)[0-9]{8}[A-Z] |                                                 # Cyprus
    (CZ)[0-9]{8,10} |                                                   # Czech Republic
    (DE)[0-9]{9} |                                                      # Germany
    (DK)[0-9]{8} |                                                      # Denmark
    (EE)[0-9]{9} |                                                      # Estonia
    (EL|GR)[0-9]{9} |                                                   # Greece
    (ES)[0-9A-Z][0-9]{7}[0-9A-Z] |                                      # Spain
    (FI)[0-9]{8} |                                                      # Finland
    (FR)[0-9A-HJ-NP-Z]{2}[0-9]{9} |                                     # France
    (HU)[0-9]{8} |                                                      # Hungary
    (IE)[0-9]{7}[A-Z]{1,2}|(IE)[0-9]{1}[A-Z]{1}[0-9]{5}[A-Z]{1} |       # Ireland
    (IT)[0-9]{11} |                                                     # Italy
    (HR)[0-9]{11}                                                       # Croatia
    (LT)([0-9]{9}|[0-9]{12}) |                                          # Lithuania
    (LU)[0-9]{8} |                                                      # Luxembourg
    (LV)[0-9]{11} |                                                     # Latvia
    (MT)[0-9]{8} |                                                      # Malta
    (NL)[0-9]{9}B[0-9]{2} |                                             # Netherlands
    (PL)[0-9]{10} |                                                     # Poland
    (PT)[0-9]{9} |                                                      # Portugal
    (RO)[0-9]{2,10} |                                                   # Romania
    (SE)[0-9]{12} |                                                     # Sweden
    (SI)[0-9]{8} |                                                      # Slovenia
    (SK)[0-9]{10} |                                                     # Slovakia

    the following countries are not technically EU, but their VAT numbers are part of the "EU-style" VAT regex anyway.
    (NO)[0-9]{9}                                                        # Norway (non-EU workaround)
    (GB|XI)([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3}) |                     # United Kingdom
    */
    EU_VAT_NUMBER:
        /^((AT)U[0-9]{8}|(BE)[0-9]{10}|(BG)[0-9]{9,10}|(CY)[0-9]{8}[A-Z]|(CZ)[0-9]{8,10}|(DE)[0-9]{9}|(DK)[0-9]{8}|(EE)[0-9]{9}|(EL|GR)[0-9]{9}|(ES)[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)[0-9]{8}|(FR)[0-9A-HJ-NP-Z]{2}[0-9]{9}|(GB|XI)([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)[0-9]{8}|(IE)[0-9]{7}[A-Z]{1,2}|(IE)[0-9]{1}[A-Z]{1}[0-9]{5}[A-Z]{1}|(IT)[0-9]{11}|(HR)[0-9]{11}|(LT)([0-9]{9}|[0-9]{12})|(LU)[0-9]{8}|(LV)[0-9]{11}|(MT)[0-9]{8}|(NL)[0-9]{9}B[0-9]{2}|(PL)[0-9]{10}|(PT)[0-9]{9}|(RO)[0-9]{2,10}|(SE)[0-9]{12}|(SI)[0-9]{8}|(SK)[0-9]{10}|(NO)[0-9]{9})$/,
    G5_PLUS_MODELS: /Livo|Liviqo/i,
    PAYTER_TERMINAL_ID: /^(APO|APM|P6X|P68)\S{11}$/,
};

export const ERROR_CODES = {
    400: 'generic.error.badRequest',
    401: 'generic.error.unauthorised',
    403: 'generic.error.forbidden',
    404: 'generic.error.notFound',
    405: 'generic.error.methodNotAllowed',
    408: 'generic.error.timeout',
    409: 'generic.error.conflict',
    413: 'generic.error.entityTooLarge',
    415: 'generic.error.unsupportedMediaType',
    417: 'generic.error.expectationFailed',
    500: 'generic.error.internalServerError',
    502: 'generic.error.internalServerError',
    503: 'generic.error.internalServerError',
    '-1': 'generic.error.timeout',
    unknown: 'generic.error.unknown',
};

export const EVENTS = {
    GENERIC: {
        NOTIFICATION: 'generic.notification',
        NOTIFICATION_SUCCESS: 'generic.notification.success',
        PROFILE_CHANGE: 'generic.profile.change',
        FAVICON_CHANGE: 'generic.favicon.change',
        USER_PROFILE_CHANGE: 'generic.user.profile.change',
        NOTIFICATION_COMPONENT_READY: 'generic.notificationComponent.ready',
        DATA_LOADING: 'generic.data.loading',
        CONTEXT_TITLE: 'generic.context.title',
        LANGUAGE_CHANGE: 'generic.language.change',
        SESSION_DATA_LOADED: 'generic.session.loaded',
        SUBSCRIPTION_UPGRADED: 'generic.subscription.upgraded',
    },
    ACTION: {
        CLOSE_NOTIFICATION: 'action.notification.close',
        TOGGLE_NAV: 'action.navigation.toggle',
        LOGO_UPDATE: 'action.logo.update',
        NAV_UPDATE: 'action.nav.update',
        STEPS: {
            NEXT: 'action.steps.next',
            PREV: 'action.steps.prev',
            COMPLETED: 'action.steps.completed',
            CURRENT: 'action.steps.current',
        },
    },
};

export const USER_ERRORS = {
    NOT_FOUND: {
        code: 'US0001',
        translationKey: 'users.error.notFound',
    },
    ALREADY_EXISTS: {
        code: 'US0002',
        translationKey: 'users.error.exists',
    },
    ACTIVATION_FAILED: {
        code: 'US0003',
        translationKey: 'users.error.activationFailed',
    },
    ACTIVATION_LINK_EXPIRED: {
        code: 'US1001',
        translationKey: 'landing.registration.notification.expiredLink',
    },
    APPLICATION_NOT_FOUND: {
        code: 'US0004',
        translationKey: 'users.error.applicationNotFound',
    },
    INVALID_STATE: {
        code: 'US0005',
        translationKey: 'users.error.invalidState',
    },
    ACTION_NOT_ALLOWED: {
        code: 'US0006',
        translationKey: 'users.error.actionNotAllowed',
    },
    INVALID_REQUEST: {
        code: 'US0007',
        translationKey: 'users.error.invalidRequest',
    },
    TENANT_NOT_FOUND: {
        code: 'US0008',
        translationKey: 'users.error.tenantNotFound',
    },
    UNAUTHORISED: {
        code: 'US0009',
        translationKey: 'users.error.unauthorised',
    },
    RECOVERY_LINK_EXPIRED: {
        code: 'US0010',
        translationKey: 'users.error.recoveryLinkExpired',
    },
    MISSING_FIELD_ACCOUNT_NAME: {
        code: 'US0011',
        translationKey: 'users.error.missingFieldAccountName',
    },
    MISSING_FIELD_ACCOUNT_ID: {
        code: 'US0012',
        translationKey: 'users.error.missingFieldAccountId',
    },
    ACCOUNT_NAME_ALREADY_EXITS: {
        code: 'US0013',
        translationKey: 'users.error.accountNameAlreadyExits',
    },
    ACCOUNT_NOT_FOUND: {
        code: 'US0014',
        translationKey: 'users.error.accountNotFound',
    },
    PASSWORD_REQUIREMENT_NOT_MET: {
        code: 'US0016',
        translationKey: 'users.error.passwordRequirementNotMeet',
    },
    INVALID_PASSWORD: {
        code: 'US0025',
        translationKey: 'generic.error.invalidPassword',
    },
    INTERNAL_SERVER_ERROR: {
        code: 'US9999',
        translationKey: 'users.error.internalServerError',
    },
};

/**
 * Object with translation key for error code directly accessible via error code, meaning its shape is:
 * {
 *     US0001: 'users.error.notFound'
 *     US0002: 'users.error.exists'
 *     ...
 *     ...
 * }
 *
 * This way there is no need to search/filter the `USER_ERRORS` object everytime an error needs to be managed to get the
 * translation key for a specific error code, just `USER_ERRORS_COPIES_BY_CODE[errorCode]` is enough.
 *
 * It is being generated from the `USER_ERRORS` object to keep alignment at all times. If new errors are needed add them
 * to the `USER_ERRORS` object to get them in `USER_ERRORS_COPIES_BY_CODE` out of the box.
 */
export const USER_ERRORS_COPIES_BY_CODE = Object.values(USER_ERRORS).reduce(
    (acc, { code, translationKey }) => {
        acc[code] = translationKey;

        return acc;
    },
    {}
);

export const COUNTRIES = {
    US: 'US',
    EU: [
        'AT',
        'BE',
        'BG',
        'CY',
        'CZ',
        'DE',
        'DK',
        'EE',
        'EL',
        'ES',
        'FI',
        'FR',
        'HU',
        'IE',
        'IT',
        'HR',
        'LT',
        'LU',
        'LV',
        'MT',
        'NL',
        'PL',
        'PT',
        'RO',
        'SE',
        'SI',
        'SK',
    ],
    EU_COMPATIBLE_VAT: ['GB', 'NO'],
};

/**
 * Out of 27 total supported countries on CMS, these 8 are "core". The remaining 19 "non-core" countries will get restrictions applied to accounts, signups, etc. at a faster rate.
 * Storing these values here allows some faster UI-only implementations, since the API `supported-countries` endpoint isn't very flexible.
 */
export const WIND_DOWN_CMS_COUNTRIES = {
    CORE: ['NL', 'DE', 'FR', 'BE', 'GB', 'IE', 'NO', 'MC'],
    // NON_CORE: []
};

export const STORAGE = {
    CARD_ADD: 'newCard',
    STATION_ADD: 'newStation',
    OKTA_USER_MANAGEMENT: '$okta_umg$',
    BP_VISITED: 'BUSINESS_PORTAL_VISITED',
    COMMUNITY_CHARGING_ENABLED: 'COMMUNITY_CHARGING_ENABLED',
    EMAIL_VERIFICATION_PARAMS: 'EMAIL_VERIFICATION_PARAMS',
    CUSTOMERS_NOTIFICATION_DISMISSED: 'CUSTOMERS_NOTIFICATION_DISMISSED',
    HAS_NEW_PASSWORD: 'HAS_NEW_PASSWORD',
};

export const MIME_TYPES = {
    LOGO: ['image/*'],
    CSV: 'text/csv',
};

export const PATHS = {
    MAP_BACKGROUND_DEFAULT:
        'data:image/jpeg;base64,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',
    MAP_MARKER_ICON_POI:
        'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzMiAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEwMV8xMTIpIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zMS43NSAxNi4yNUMzMS43NSA3LjU1MSAyNC42OTggMC41IDE2IDAuNUM3LjMwMSAwLjUgMC4yNSA3LjU1MSAwLjI1IDE2LjI1QzAuMjUgMjMuNjEzIDUuMzA5IDI5Ljc3NyAxMi4xMzYgMzEuNTAyTDE2IDM3LjM1OEwxOS44NjQgMzEuNTAyQzI2LjY5IDI5Ljc3NyAzMS43NSAyMy42MTMgMzEuNzUgMTYuMjVaIiBmaWxsPSIjMTAxRDgzIi8+CjxwYXRoIGQ9Ik0xNiA2QzE4Ljc2MTQgNiAyMSA4LjIzODU4IDIxIDExQzIxIDEzLjQzNzYgMTkuMjU1NyAxNS40Njc4IDE2Ljk0NzIgMTUuOTEwNEwxNi41IDI3SDE1LjVMMTUuMDUxOCAxNS45MTAyQzEyLjc0MzggMTUuNDY3MiAxMSAxMy40MzcyIDExIDExQzExIDguMjM4NTggMTMuMjM4NiA2IDE2IDZaTTE2IDhDMTQuMzQzMSA4IDEzIDkuMzQzMTUgMTMgMTFDMTMgMTIuNjU2OSAxNC4zNDMxIDE0IDE2IDE0QzE3LjY1NjkgMTQgMTkgMTIuNjU2OSAxOSAxMUMxOSA5LjM0MzE1IDE3LjY1NjkgOCAxNiA4WiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xMDFfMTEyIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjM4IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=',
    MAP_MARKER_ICON_DEFAULT:
        'data:image/svg+xml;base64,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',
    DEFAULT_BRANDING_IMAGES: {
        LOGO: 'images/everon-logo.png',
        BRAND: 'images/everon-brand.jpg',
        ICON: 'images/everon-icon.png',
    },
};

export const CONNECTOR_STATUS = {
    // TODO: https://myevbox.atlassian.net/browse/FETCH-918
    COLORS: {
        available: 'var(--color-feedback-success, #27aa5e)',
        charging: 'var(--color-feedback-info-dark, #004d99)',
        reserved: 'var(--color-feedback-info, #0070e0)',
        occupied: '#3bbdf5',
        unavailable: '#f99a2b',
        outOfOrder: 'var(--color-feedback-danger, #cc3a39)',
        offline: 'var(--color-neutral-4, #CECED3)',
    },
    LABELS: {
        available: 'generic.status.available',
        charging: 'generic.status.charging',
        reserved: 'generic.status.reserved',
        occupied: 'generic.status.occupied',
        unavailable: 'generic.status.unavailable',
        outOfOrder: 'generic.status.outOfOrder',
        offline: 'generic.status.offline',
    },
};

export const STATION_LIFECYCLE_STATES = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    DEACTIVATED: 'DEACTIVATED',
};

export const STATION_CONNECTIVITY_STATUSES = {
    ONLINE: 'ONLINE',
    OFFLINE: 'OFFLINE',
};

export const STATION_LIST_VIEWS = {
    SEARCH: 'search',
    ONLINE: 'online',
    OFFLINE: 'offline',
    ACTIVE: 'active',
    INACTIVE: 'inactive',
};

export const CPO_DASHBOARD = {
    CONNECTOR_STATUSES: [
        'available',
        'charging',
        'reserved',
        'occupied',
        'unavailable',
        'outOfOrder',
    ],
};

export const SUPPORT_TEAMS = {
    ROLES: {
        admin: 'admin',
        contributor: 'contributor',
    },
};

export const REIMBURSEMENT_RATE_EXCESS_THRESHOLDS = {
    EUR: 1.5,
    NOK: 10,
    SEK: 10,
    GBP: 1.5,
    DKK: 8,
    PLN: 2,
    CZK: 14,
    CHF: 1.5,
    BGN: 0.8,
    HUF: 120,
    HRK: 4,
    ISK: 60,
    default: 200,
};

export const ACCOUNT_TYPES = {
    BUSINESS: 'business',
    CONSUMER: 'consumer',
    UNSPECIFIED: 'unspecified',
};
export const ACCOUNT_SUBSCRIPTION_TYPES = {
    STANDARD: 'standard',
    CUSTOM_OFFER: 'custom-offer',
};

export const ACCOUNT_SUBSCRIPTION_STATUSES = {
    PENDING: 'CREATED',
    ACTIVE: 'ACTIVATED',
};

export const SUBSCRIPTIONS = {
    FEATURES: {
        MAX_STATIONS_AMOUNT: 'MAX_STATIONS_AMOUNT',
        MAX_TOKENS_AMOUNT: 'MAX_TOKENS_AMOUNT',
        SUB_ACCOUNT_CREATION: 'SUB_ACCOUNT_CREATION',
        TOKEN_PUBLIC_CHARGING: 'TOKEN_PUBLIC_CHARGING',
        CHARGING_PROFILES: 'CHARGING_PROFILES',
        STATION_PUBLIC_CHARGING: 'STATION_PUBLIC_CHARGING',
        BUSINESS_PORTAL: 'BUSINESS_PORTAL',
        DRIVER_REIMBURSEMENT: 'DRIVER_REIMBURSEMENT',
    },
    TYPES: {
        ACCOUNT: 'ACCOUNT',
        CUSTOM_OFFERING: 'CUSTOM_OFFERING',
        ASSET: 'ASSET',
    },
    STATUS: {
        ACTIVATED: 'ACTIVATED',
        CREATED: 'CREATED',
    },
};

export const STATION_TYPES = {
    ONLINE: {
        TITLE: 'generic.status.online',
        ICON: 'icon-energy',
        TOOLTIP: 'stations.types.online.tooltip',
    },
    OFFLINE: {
        TITLE: 'generic.status.offline',
        ICON: 'icon-offline',
        TOOLTIP: 'stations.types.offline.tooltip',
    },
    INACTIVE: {
        TITLE: 'generic.status.inactive',
        ICON: 'icon-energy-disabled',
        TOOLTIP: 'stations.types.inactive.tooltip',
    },
};

export const RESOURCE_TYPE = {
    TOKENS: 'TOKENS',
    STATIONS: 'STATIONS',
};

export const CONNECTORS_STANDARDS = {
    CHADEMO: {
        ICON: 'icon-chademo',
        LABEL: 'generic.stationConnectorType.chademo',
    },
    DOMESTIC_A: {
        ICON: 'icon-domestic-a',
        LABEL: 'generic.stationConnectorType.domesticA',
    },
    DOMESTIC_B: {
        ICON: 'icon-domestic-b',
        LABEL: 'generic.stationConnectorType.domesticB',
    },
    DOMESTIC_C: {
        ICON: 'icon-domestic-c',
        LABEL: 'generic.stationConnectorType.domesticC',
    },
    DOMESTIC_D: {
        ICON: 'icon-domestic-d',
        LABEL: 'generic.stationConnectorType.domesticD',
    },
    DOMESTIC_E: {
        ICON: 'icon-domestic-e',
        LABEL: 'generic.stationConnectorType.domesticE',
    },
    DOMESTIC_F: {
        ICON: 'icon-domestic-f',
        LABEL: 'generic.stationConnectorType.domesticF',
    },
    DOMESTIC_G: {
        ICON: 'icon-domestic-g',
        LABEL: 'generic.stationConnectorType.domesticG',
    },
    DOMESTIC_H: {
        ICON: 'icon-domestic-h',
        LABEL: 'generic.stationConnectorType.domesticH',
    },
    DOMESTIC_I: {
        ICON: 'icon-domestic-i',
        LABEL: 'generic.stationConnectorType.domesticI',
    },
    DOMESTIC_J: {
        ICON: 'icon-domestic-j',
        LABEL: 'generic.stationConnectorType.domesticJ',
    },
    DOMESTIC_K: {
        ICON: 'icon-domestic-k',
        LABEL: 'generic.stationConnectorType.domesticK',
    },
    DOMESTIC_L: {
        ICON: 'icon-domestic-l',
        LABEL: 'generic.stationConnectorType.domesticL',
    },
    IEC_62196_T1: {
        ICON: 'icon-iec-62196-t1',
        LABEL: 'generic.stationConnectorType.iec62196T1',
    },
    IEC_62196_T1_COMBO: {
        ICON: 'icon-iec-62196-t1-combo',
        LABEL: 'generic.stationConnectorType.iec62196T1Combo',
    },
    IEC_62196_T2: {
        ICON: 'icon-iec-62196-t2',
        LABEL: 'generic.stationConnectorType.iec62196T2',
    },
    IEC_62196_T2_COMBO: {
        ICON: 'icon-iec-62196-t2-combo',
        LABEL: 'generic.stationConnectorType.iec62196T2Combo',
    },
    IEC_62196_T3A: {
        ICON: 'icon-iec-62196-t3a',
        LABEL: 'generic.stationConnectorType.iec62196T3A',
    },
    IEC_62196_T3C: {
        ICON: 'icon-iec-62196-t3c',
        LABEL: 'generic.stationConnectorType.iec62196T3C',
    },
    TESLA_R: {
        ICON: 'icon-tesla-r',
        LABEL: 'generic.stationConnectorType.teslaR',
    },
    TESLA_S: {
        ICON: 'icon-tesla-s',
        LABEL: 'generic.stationConnectorType.teslaS',
    },
};

export const SETUP_FLOWS = {
    SELF: 'SELF_SIGNUP',
    ON_BEHALF: 'ONBOARDING_ON_BEHALF',
    EMPLOYEE: 'EMPLOYEE_ONBOARDING',
};

export const CARD_TYPES = ['all', 'virtual', 'iso14443'];

export const CARD_STATES = {
    virtual: ['all', 'active', 'blocked'],
    iso14443: [
        'all',
        'active',
        'blocked',
        'inactive',
        'deactivated',
        'pending',
    ],
};

export const BILLING_CYCLES = {
    MONTHLY: 'monthly',
};

export const VALUES = {
    TRANSACTION: {
        MIN: 0.0,
        MAX: 99999999.99,
    },
    CONNECTOR_VOLTAGE: {
        MIN: 110,
        MAX: 1000,
    },
    CONNECTOR_AMPERAGE: {
        MIN: 1,
        MAX: 500,
    },
};

export const CREDIT_CARD_TYPE = 'virtual';

export const INVITATION_OPERATING_LEVEL = {
    TENANT: 'TENANT',
    PARENT: 'PARENT_ACCOUNT',
    CHILD: 'CHILD_ACCOUNT',
    PARENT_CREATE: 'PARENT_ACCOUNT_CREATE',
    CHILD_CREATE: 'CHILD_ACCOUNT_CREATE',
};

/**
 * Error messages for mapping those coming from the services as plain english text.
 * The goal is to surface these messages to the user in their own language.
 * @typedef {Object} CustomErrorMessage
 * @property {string|RegExp} key - The message key coming from the service
 * @property {string} translationKey - The translation in our translations repo.
 * @property {Array<string>} interpolationVars - The variables that will match an interpolated string in the translation
 */

/**
 * Object for matching custom error messages from the services.
 * @type {Array<CustomErrorMessage>}
 */
export const ERROR_MESSAGES = [
    {
        key: 'Station not found for id',
        translationKey:
            'stations.station.error.payter.activation.stationNotFound',
    },
    {
        key: 'The power type is not supported for station id',
        translationKey: 'stations.station.error.payter.activation.powerType',
    },
    {
        key: 'Public charging is not enabled for station id',
        translationKey:
            'stations.station.error.payter.activation.publicCharging',
    },
    {
        key: 'The terminal is already linked to another station, please check the backside of the terminal for the ID',
        translationKey:
            'stations.station.error.payter.activation.terminalAlreadyLinked',
    },
    {
        // In regex keys, we use () to capture values from the original string. those values can be interpolated using interpolationVars
        key: /Folder with name '(.*?)' already exists./,
        // This is used to give names to the captured values in the regex, the order should be the same as the order of capturing.
        interpolationVars: ['name'],
        translationKey:
            'account.billing.error.folders.accountNameAlreadyExists',
    },
    {
        key: 'Billing information not found for account id',
        translationKey: 'generic.error.billingInfoNotFound',
    },
    {
        key: 'Unable to read the file',
        translationKey: 'generic.error.readFile',
    },
    {
        key: 'Phone number must have length from 6 to 20.',
        translationKey: 'generic.error.phoneNumberLength',
    },
];

export const PAYTER_STATUSES = {
    INACTIVE: 'INACTIVE',
    PENDING_ACTIVATION: 'PENDING_ACTIVATION',
    ACTIVE: 'ACTIVE',
    PENDING_DEACTIVATION: 'PENDING_DEACTIVATION',
    UNKNOWN: 'UNKNOWN',
};

export const ASSET_TYPE = {
    CARD: 'CARD',
    STATION: 'STATION',
};
export const PAYMENT_PROVIDER = {
    PAYTER_STATUS: {
        IDLE: 'idle',
        ACTIVE: 'active',
        READING: 'reading',
        AUTHORIZING: 'authorizing',
        STOPPING: 'stopping',
        CARD: 'card',
        UNKNOWN: 'unknown',
        OFFLINE: 'offline',
    },
};
export const ROAMING_ADD_ON_ACTIVATION_TEXTS = {
    title: [
        'subscription.upgrade.addon.card.roaming.title',
        'Add card roaming?',
    ],
    description: [
        'subscription.upgrade.addon.card.roaming.description',
        'Your card is currently working with your stations only. Add roaming to access more than 175,000 charging stations across Europe.',
    ],
    cancellation: [
        'subscription.upgrade.addon.cancellation',
        'Renewed automatically. Cancel at any time.',
    ],
    icon: 'illustration-card-roaming',
};

export const INVOICE_TYPES = {
    SUBSCRIPTIONS_INVOICE_WITH_CARD_TRANSACTIONS:
        'SUBSCRIPTIONS_INVOICE_WITH_CARD_TRANSACTIONS',
    STATION_TRANSACTION: 'STATION_TRANSACTION',
    SUBSCRIPTIONS_NO_TRANSACTIONS: 'SUBSCRIPTIONS_NO_TRANSACTIONS',
    JBILLING: 'JBILLING',
};

export const VAT_CATEGORIZATION_TYPES = {
    EXEMPT: 'EXEMPT',
    STANDARD: 'STANDARD',
    SMALL_BUSINESS_SCHEME: 'SMALL_BUSINESS_SCHEME',
};

export const MATOMO_CONTAINER_IDS = {
    // Container IDs are available on the Tag Manager section of the Matomo platform
    PRODUCTION: 'PfdONmoF',
    SANDBOX: 'GYUndVgA',
};

export const ASYNC_STATES = {
    LOADING: 'LOADING',
    FAILED: 'FAILED',
    SUCCEEDED: 'SUCCEEDED',
};

export const PARKED_BILLING_REASONS = [
    {
        name: 'parkedBilling.reason.incorrectVatNumber',
        value: 'INCORRECT_VAT_NUMBER',
    },
    {
        name: 'parkedBilling.reason.unpaidBills',
        value: 'UNPAID_BILLS',
    },
    {
        name: 'parkedBilling.reason.other',
        value: 'OTHER',
    },
    {
        name: 'Automatic VAT check',
        value: 'AUTOMATED_VAT_CHECK',
    },
];

// This `STATION_NAMES` constant violates our architectural constraints. Do not extend it.
// Distinguishing between station models should go through the capabilities API:
// https://developers.everon.io/docs/capability-public-api/1/routes/%7BstationId%7D/capabilities/get
export const STATION_NAMES = {
    LIVIQO: 'liviqo',
};
